import { FC } from 'react';

import { Button } from '@purpur/library';

import { Modal } from '@telialt/common-modal/src';

import { LEAD_MODAL_BANNER_IMAGE } from '../../constants';
import { LeadModalProps } from '../../model';
import { LeadProvider } from '../../providers/LeadProvider';
import { LeadForm } from '../LeadForm';
import { CloseContainer, CloseIcon, ContentCol, ModalContent, ModalWrapper, SideImgCol } from './LeadModal.styles';

export const LeadModal: FC<LeadModalProps> = ({
    bannerImage = LEAD_MODAL_BANNER_IMAGE,
    isOpen,
    onClose,
    dataTest,
    ...props
}) => {
    return (
        <LeadProvider>
            <Modal
                isShown={isOpen}
                onHide={onClose}
                size="lg"
                bodyContentClassName=""
                fixedDesktopHeight="40rem"
                dataTest={dataTest}
            >
                <ModalWrapper>
                    <SideImgCol>
                        <img src={bannerImage} alt="" />
                    </SideImgCol>
                    <ContentCol>
                        <CloseContainer>
                            <Button type="button" variant="text" onClick={onClose}>
                                <CloseIcon type="close" />
                            </Button>
                        </CloseContainer>
                        <ModalContent>
                            <LeadForm {...props} />
                        </ModalContent>
                    </ContentCol>
                </ModalWrapper>
            </Modal>
        </LeadProvider>
    );
};
